import { ReactNode } from "react";
import { HTMLLevels } from "~/components/Heading";
import { SectionHeading } from "~/components/SectionHeading";

function SingleType({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

function SingleTypeHeading({ children }: { children: ReactNode }) {
  return (
    <div className="lg:mx-28 xl:mx-48">
      <SectionHeading>
        <SectionHeading.Title level={HTMLLevels.h1} className="mb-8">
          {children}
        </SectionHeading.Title>
      </SectionHeading>
    </div>
  );
}

function SingleTypeContent({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={`lg:mx-28 xl:mx-48 mb-8 ${className ?? ""}`}>{children}</div>;
}

SingleType.Heading = SingleTypeHeading;
SingleType.Content = SingleTypeContent;

export default SingleType;
